import { NativeStackScreenProps } from "@react-navigation/native-stack";

export enum ROUTES {
  KHET_EDGE = "KhetEdge",
  ADVISORY = "Advisory",
  CROPS = "Crops",
}

export enum SCREEN_NAMES {
  KHET_EDGE = "KhetEdge",
  CROPS = "KhetEdge",
  ADVISORY = "Crop Advisory",
}

export type RootStackParamList = {
  [ROUTES.KHET_EDGE]:
    | {
        ph: string;
      }
    | undefined;
  [ROUTES.ADVISORY]: {
    advisoryId: string;
  };
  [ROUTES.CROPS]: undefined;
};

export type KhetEdgeScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.KHET_EDGE
>;

export type AdvisoryScreenProps = NativeStackScreenProps<
  RootStackParamList,
  ROUTES.ADVISORY
>;
